import { useContent } from "src/shared/components/content";
import { contentIds } from "./contentIds";

export const useTrustCardContent = () => ({
  heading: useContent(contentIds.heading),
  ticketsSold: useContent(contentIds.ticketsSold),
  validAndOnTime: useContent(contentIds.validAndOnTime),
  protection: useContent(contentIds.protection),
});

export const hasTrustCardContent = (content: ReturnType<typeof useTrustCardContent>): boolean =>
  !!content.heading && !!content.ticketsSold && !!content.validAndOnTime && !!content.protection;
